import axios from "axios";

const baseURL = "/api/cdk/card-on-file/v1";
const URL = {
  loadAll: `${baseURL}/load`,
  create: `${baseURL}/create`,
  delete: `${baseURL}/delete`,
  update: `${baseURL}/update`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const CardOnFileService = {
  loadCardOnFiles: async () => {
    try {
      const response = await axios.get(`${URL.loadAll}/`, {
        headers: HEADERS
      });
      return response.data;
    } catch (e) {
      return { hasError: true };
    }
  },

  createCardOnFile: async data => {
    try {
      const response = await axios.post(`${URL.create}/`, data, {
        headers: HEADERS
      });
      return response.data;
    } catch (e) {
      return { hasError: true };
    }
  },

  updateCardOnFile: async CofData => {
    try {
      const response = await axios.put(`${URL.update}`, CofData, {
        headers: HEADERS
      });
      return response.data;
    } catch (e) {
      return { hasError: true };
    }
  },

  deleteCardOnFilebyId: async ({ cardOnFileId }) => {
    try {
      console.log({ cardOnFileId });
      const response = await axios.delete(`${URL.delete}/${cardOnFileId}`, {
        headers: HEADERS
      });
      return response.data;
    } catch (e) {
      return { hasError: true };
    }
  }
};

export default CardOnFileService;
